const salesAndReceiptsHighlightColorMap: { [key: string]: string } = {
  "1-gross-margin": "primary.contrastText",
  "1-gross-sales": "primary.contrastText",
  "1-total-net-receipt": "primary.contrastText",
  "1-net-receipt-retail-new": "primary.contrastText",
  "1-anticipated-gross-margin": "primary.contrastText",
  "1-gross-margin-after-shrink": "primary.contrastText",
  "net-receipt-detail": "secondary.main",
  "retail-adjustments": "secondary.main",
  "1-net-warehouse-transfer-retail": "primary.contrastText",
  "1-net-warehouse-transfer-cost": "primary.contrastText",
  "1-net-non-warehouse-transfer-retail": "primary.contrastText",
  "1-net-receipts-retail-variance": "primary.contrastText",
  "1-additional-pos-sales-retail": "primary.contrastText",
  "1-possales-retail": "primary.contrastText"
};

const salesAndReceiptsTextColorMap: { [key: string]: string } = {
  "net-receipt-detail": "primary.dark",
  "retail-adjustments": "primary.dark",
  "1-total-net-receipt": "grey.900",
  "1-net-receipt-retail-new": "grey.900",
  "1-anticipated-gross-margin": "grey.900"
};

const borderTop: { [key: string]: boolean } = {
  "1-gross-margin": true,
  "1-total-net-receipt": true,
  "1-anticipated-gross-margin": true,
  "1-gross-margin-after-shrink": true,
  "1-net-warehouse-transfer-retail": true,
  "1-net-warehouse-transfer-cost": true,
  "1-net-non-warehouse-transfer-retail": true,
  "1-additional-pos-sales-retail": true
};

const getHighlightColor = (childKey: string, parentKey: string) =>
  salesAndReceiptsHighlightColorMap[childKey] ??
  salesAndReceiptsHighlightColorMap[parentKey];

const getTextColor = (childKey: string, parentKey: string) =>
  salesAndReceiptsTextColorMap[childKey] ??
  salesAndReceiptsTextColorMap[parentKey];

export const getSalesMarginObject = (_parentItem: any, childItem: any) => {
  return {
    title: {
      value: childItem?.text,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key]
    },
    cost: {
      value: childItem?.cost,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline
    },
    retail: {
      value: childItem?.retail,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key]
    },
    margin: {
      value: childItem?.margin,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key]
    },
    beerOrWine: {
      value: childItem?.beerorwine,
      underline: childItem?.style?.underline,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    hbc: {
      value: childItem?.hbc,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline
    },
    grocery: {
      value: childItem?.grocery,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline
    },
    frozen: {
      value: childItem?.frozen,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline
    },
    deli: {
      value: childItem?.deli,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline
    },
    gm: {
      value: childItem?.gm,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline
    },
    produce: {
      value: childItem?.produce,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline
    },
    meat: {
      value: childItem?.meat,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline
    },
    level: childItem?.level,
    isHighlightedRow: childItem?.style?.bold,
    borderTop: borderTop[childItem.key]
  };
};

export const getNetReceiptRetailObject = (parentItem: any, childItem: any) => {
  return {
    title: {
      value: childItem?.text,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      borderRight: true
    },
    grocery: {
      value: childItem?.grocery,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    cost: {
      value: childItem?.cost,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold,
      borderRight: true
    },
    retail: {
      value: childItem?.retail,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key]
    },
    margin: {
      value: childItem?.margin,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      borderRight: true
    },
    frozen: {
      value: childItem?.frozen,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    deli: {
      value: childItem?.deli,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    hbc: {
      value: childItem?.hbc,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    gm: {
      value: childItem?.gm,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    beerOrWine: {
      value: childItem?.beerorwine,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    produce: {
      value: childItem?.produce,
      bold: childItem?.style?.bold,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key)
    },
    meat: {
      value: childItem?.meat,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    level: childItem?.level,
    isHighlightedRow: childItem?.style?.bold,
    borderTop: borderTop[childItem.key]
  };
};

export const getRetailAdjustmentObject = (parentItem: any, childItem: any) => {
  return {
    title: {
      value: childItem?.text,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    frozen: {
      value: childItem?.frozen,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    deli: {
      value: childItem?.deli,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    cost: {
      value: childItem?.cost,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      borderRight: true
    },
    retail: {
      value: childItem?.retail,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key]
    },
    margin: {
      value: childItem?.margin,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      borderRight: true
    },
    gm: {
      value: childItem?.gm,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),

      bold: childItem?.style?.bold,
      textColor: getTextColor(childItem?.key, parentItem?.key)
    },
    produce: {
      value: childItem?.produce,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    grocery: {
      value: childItem?.grocery,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    beerOrWine: {
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold,
      value: childItem?.beerorwine,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key)
    },
    hbc: {
      value: childItem?.hbc,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    meat: {
      value: childItem?.meat,
      highlightColor: getHighlightColor(childItem?.key, parentItem?.key),
      textColor: getTextColor(childItem?.key, parentItem?.key),
      bold: childItem?.style?.bold
    },
    level: childItem?.level,
    borderTop: borderTop[childItem.key],
    isHighlightedRow: childItem?.style?.bold
  };
};

export const getPhysicalInventoryAdjustmentObject = (
  _parentItem: any,
  childItem: any
) => {
  return {
    title: {
      value: childItem?.text,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key]
    },
    cost: {
      value: childItem?.cost,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    retail: {
      value: childItem?.retail,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key]
    },
    margin: {
      value: childItem?.margin,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key]
    },
    grocery: {
      value: childItem?.grocery,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    frozen: {
      value: childItem?.frozen,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    deli: {
      value: childItem?.deli,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    beerOrWine: {
      value: childItem?.beerorwine,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    hbc: {
      value: childItem?.hbc,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    gm: {
      value: childItem?.gm,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    produce: {
      value: childItem?.produce,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    meat: {
      value: childItem?.meat,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    level: childItem?.level,
    borderTop: borderTop[childItem.key],
    isHighlightedRow: childItem?.style?.bold
  };
};

export const getAdditionalInTransitObject = (
  _parentItem: any,
  childItem: any
) => {
  return {
    title: {
      value: childItem?.text,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key]
    },
    hbc: {
      value: childItem?.hbc,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    gm: {
      value: childItem?.gm,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    frozen: {
      value: childItem?.frozen,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    deli: {
      value: childItem?.deli,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    beerOrWine: {
      value: childItem?.beerorwine,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    produce: {
      value: childItem?.produce,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    cost: {
      value: childItem?.cost,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    grocery: {
      value: childItem?.grocery,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    meat: {
      value: childItem?.meat,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold
    },
    retail: {
      value: childItem?.retail,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key]
    },
    margin: {
      value: childItem?.margin,
      bold: childItem?.style?.bold,
      highlightColor: salesAndReceiptsHighlightColorMap[childItem?.key]
    },
    level: childItem?.level,
    borderTop: borderTop[childItem.key],
    isHighlightedRow: childItem?.style?.bold
  };
};
